import axios from 'axios';
import { API_URL } from 'config';

// axios docs: https://github.com/axios/axios/blob/master/README.md
// Request config: https://github.com/axios/axios/blob/master/README.md#request-config
const apiRequest = (function createApiRequest() {
  return axios.create({
    baseURL: API_URL,
    // In milliseconds.
    timeout: 15_000,
  });
})();

export default apiRequest;
